import type { KambiEvent, KambiListView } from '@mobi/api-types/kambi'
import { simpleFetch } from '@mobi/utils/fetch/simpleFetch'

export function getEventsForGroupId(groupId: number) {
  return simpleFetch<{ events: KambiEvent[] }>(
    `${window._kc.apiOfferingBaseUrl}event/group/${groupId}?includeParticipants=true&lang=en_AU&market=AU`
  )
}

export function getUpcomingEventsForAllSports() {
  return simpleFetch<KambiListView>(
    `${window._kc.apiOfferingBaseUrl}listView/all/all/all/all/starting-soon.json?lang=en_AU&market=AU&useCombined=true`
  )
}

export function getLiveEventsForAllSports() {
  return simpleFetch<KambiListView>(
    `${window._kc.apiOfferingBaseUrl}listView/all/all/all/all/in-play.json?lang=en_AU&market=AU&useCombined=true&includeParticipants=true`
  )
}
